"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BaseNumberInput = _interopRequireDefault(require("../BaseNumberInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PhoneNumberInput(props) {
  var isintl = props.isintl.toString() === 'true';

  if (isintl) {
    // returns international format as it came back from API
    var num = props.value.replace(/[0-9]/g, '#');
    return /*#__PURE__*/_react["default"].createElement(_BaseNumberInput["default"], _extends({}, props, {
      isNumericFormat: false,
      inputProps: _objectSpread({
        format: num
      }, props.inputProps)
    }));
  } else {
    // returns US format
    return /*#__PURE__*/_react["default"].createElement(_BaseNumberInput["default"], _extends({}, props, {
      isNumericFormat: false,
      inputProps: _objectSpread({
        format: '(###) ###-####',
        mask: '_'
      }, props.inputProps)
    }));
  }
}

_BaseNumberInput["default"].extendProps(PhoneNumberInput);

var _default = PhoneNumberInput;
exports["default"] = _default;
PhoneNumberInput.propTypes = {
  isintl: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  value: _propTypes["default"].string,
  inputProps: _propTypes["default"].object
};